<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div class="row" v-if="userData.permissions['new_patient']==1">
      <div class="col-lg-12">
        <div class="card border-0 shadow-sm">
          <div class="card-body p-0">
            <div class="p-3 border-bottom">
              <div class="mb-0 float-end">
                <b-button variant="info" size="sm" @click="openImportPatientsModal">
                  <i class="mdi mdi-file-import"></i> Import Patients
                </b-button>
              </div>
              <div class="clearfix"></div>
            </div>
            <form @submit.prevent="handlePatientSubmit">
              <div class="row g-4">
                
                <!-- Left Column - Patient Photo & Basic Info -->
                <div class="col-lg-4">
                  <div class="card border-0 bg-light h-100">
                    <div class="card-body">
                      <h5 class="card-title mb-3 fw-bold">
                        <i class="mdi mdi-account-circle text-primary"></i> Patient Information
                      </h5>
                      
                      <!-- Photo Capture Section -->
                      <!-- <div class="mb-4">
                        <label class="form-label fw-medium">Patient Photo</label>
                        <div class="row g-2">
                          <div class="col-6">
                            <div class="photo-container rounded border">
                              <vue-web-cam 
                                height="100" 
                                ref='webcam' 
                                :autoplay="true" 
                                :selectFirstDevice='selectdev'
                                class="rounded"
                              />
                            </div>
                            <b-button 
                              type="button" 
                              class="btn btn-sm btn-success w-100 mt-2" 
                              @click="take_photo"
                            >
                              <i class="mdi mdi-camera"></i> Capture
                            </b-button>
                          </div>
                          <div class="col-6">
                            <div class="photo-preview rounded border d-flex align-items-center justify-content-center" style="height: 100px;">
                              <img 
                                v-if="photo" 
                                :src="photo" 
                                class="rounded w-100 h-100" 
                                style="object-fit: cover;"
                              />
                              <div v-else class="text-center text-muted">
                                <i class="mdi mdi-account-outline" style="font-size: 48px;"></i>
                                <p class="small mb-0">No photo</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> -->

                      <!-- <hr class="my-3"> -->

                      <!-- Patient Name -->
                      <div class="form-group mb-3">
                        <label class="form-label fw-medium">
                          <i class="mdi mdi-account text-muted"></i> Patient's Name
                          <span class="text-danger">*</span>
                        </label>
                        <input 
                          class="form-control" 
                          list="patients" 
                          required 
                          @change="FilterPatient" 
                          v-model="patient_name" 
                          placeholder="Search or enter patient name..."
                        />
                        <datalist id="patients">
                          <option v-for="item in patients" :key="item.id">
                            {{ item.name }}-{{ item.patient_id }}-{{ item.telephone }}
                          </option>
                        </datalist>
                      </div>

                      <!-- Visit Date -->
                      <div class="form-group mb-3">
                        <label class="form-label fw-medium">
                          <i class="mdi mdi-calendar text-muted"></i> Visit Date
                          <span class="text-danger">*</span>
                        </label>
                        <input v-model="visitdate" type="date" class="form-control" />
                      </div>

                      <!-- Telephone -->
                      <div class="form-group mb-3">
                        <label class="form-label fw-medium">
                          <i class="mdi mdi-phone text-muted"></i> Telephone
                          <span class="text-danger">*</span>
                        </label>
                        <b-input-group :prepend="userData.countryCode">
                          <input 
                            v-model="telephone" 
                            placeholder="7XX XXX XXX" 
                            v-mask="'#########'" 
                            type="text" 
                            class="form-control"
                          />
                        </b-input-group>
                      </div>

                      <!-- Gender -->
                      <div class="form-group mb-3">
                        <label class="form-label fw-medium">
                          <i class="mdi mdi-gender-male-female text-muted"></i> Gender
                          <span class="text-danger">*</span>
                        </label>
                        <select class="form-select" v-model="gender">
                          <option>Female</option>
                          <option>Male</option>
                        </select>
                      </div>

                      <!-- Address -->
                      <div class="form-group mb-3">
                        <label class="form-label fw-medium">
                          <i class="mdi mdi-map-marker text-muted"></i> Address
                          <span class="text-danger">*</span>
                        </label>
                        <input 
                          v-model="address" 
                          placeholder="Enter residential address" 
                          type="text" 
                          class="form-control" 
                        />
                      </div>
                      <div class="form-group mb-3">
                        <label class="form-label fw-medium">
                          <i class="mdi mdi-flag text-muted"></i> Nationality
                          <span class="text-danger">*</span>
                        </label>
                        <multiselect 
                          v-model="nationality" 
                          :options="countries" 
                          label="name"
                          placeholder="Select nationality"
                        />
                      </div>

                    </div>
                  </div>
                </div>

                <!-- Middle Column - Personal Details -->
                <div class="col-lg-4">
                  <div class="card border-0 bg-light h-100">
                    <div class="card-body">
                      <h5 class="card-title mb-3 fw-bold">
                        <i class="mdi mdi-card-account-details text-primary"></i> Personal Details
                      </h5>

                      <!-- Nationality -->
                      

                      <!-- Input Type Selection -->
                      <div class="form-group mb-3">
                        <label class="form-label fw-medium">
                          <i class="mdi mdi-calendar-clock text-muted"></i> Age Input Type
                          <span class="text-danger">*</span>
                        </label>
                        <select 
                          v-model="inputType" 
                          class="form-select" 
                          @change="handleInputTypeChange"
                        >
                          <option value="dateofbirth">Date of Birth</option>
                          <option value="age">Age</option>
                        </select>
                      </div>

                      <!-- Date of Birth -->
                      <div class="form-group mb-3" v-if="inputType === 'dateofbirth'">
                        <label class="form-label fw-medium">
                          <i class="mdi mdi-cake text-muted"></i> Date of Birth
                          <span class="text-danger">*</span>
                        </label>
                        <input v-model="dateofbirth" type="date" class="form-control" />
                      </div>

                      <!-- Age Input -->
                      <div class="form-group mb-3" v-else-if="inputType === 'age'">
                        <label class="form-label fw-medium">
                          <i class="mdi mdi-counter text-muted"></i> Age
                          <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <input 
                            v-model.number="ageValue" 
                            type="number" 
                            class="form-control" 
                            placeholder="Enter age"
                            @input="calculateDateOfBirth"
                          />
                          <select 
                            v-model="ageUnit" 
                            class="form-select" 
                            style="max-width: 120px;"
                            @change="calculateDateOfBirth"
                          >
                            <option value="years">Years</option>
                            <option value="months">Months</option>
                            <option value="weeks">Weeks</option>
                            <option value="days">Days</option>
                          </select>
                        </div>
                      </div>

                      <!-- Email -->
                      <div class="form-group mb-3">
                        <label class="form-label fw-medium">
                          <i class="mdi mdi-email text-muted"></i> Email Address
                          <span class="text-muted small">(optional)</span>
                        </label>
                        <input 
                          v-model="email" 
                          type="email" 
                          placeholder="patient@example.com" 
                          class="form-control"
                        />
                      </div>

                      <!-- NIN/Passport -->
                      <div class="form-group mb-3">
                        <label class="form-label fw-medium">
                          <i class="mdi mdi-card-account-details-outline text-muted"></i> NIN / Passport Number
                          <span class="text-muted small">(optional)</span>
                        </label>
                        <input 
                          v-model="nin" 
                          placeholder="CM12345678901234" 
                          type="text" 
                          class="form-control" 
                        />
                      </div>

                      <!-- Next of Kin Name -->
                      <div class="form-group mb-3">
                        <label class="form-label fw-medium">
                          <i class="mdi mdi-account-supervisor text-muted"></i> Next of Kin Name
                          <span class="text-muted small">(optional)</span>
                        </label>
                        <input 
                          v-model="nokname" 
                          placeholder="Full name of next of kin" 
                          type="text" 
                          class="form-control" 
                        />
                      </div>

                      <!-- Next of Kin Contact -->
                      <div class="form-group mb-3">
                        <label class="form-label fw-medium">
                          <i class="mdi mdi-phone-in-talk text-muted"></i> Next of Kin Contact
                          <span class="text-muted small">(optional)</span>
                        </label>
                        <input 
                          v-model="nokcontact" 
                          placeholder="Contact number" 
                          type="text" 
                          class="form-control" 
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Right Column - Payment & Service Info -->
                <div class="col-lg-4">
                  <div class="card border-0 bg-light h-100">
                    <div class="card-body">
                      <h5 class="card-title mb-3 fw-bold">
                        <i class="mdi mdi-cash-multiple text-primary"></i> Payment & Services
                      </h5>

                      <!-- Relation with Patient -->
                      <div class="form-group mb-3">
                        <label class="form-label fw-medium">
                          <i class="mdi mdi-account-heart text-muted"></i> Relation with Patient
                          <span class="text-muted small">(optional)</span>
                        </label>
                        <input 
                          v-model="nokrelationship" 
                          placeholder="e.g., Spouse, Parent, Sibling" 
                          type="text" 
                          class="form-control" 
                        />
                      </div>

                      <!-- Payment Type -->
                      <div class="form-group mb-3">
                        <label class="form-label fw-medium">
                          <i class="mdi mdi-credit-card text-muted"></i> Payment Type
                          <span class="text-danger">*</span>
                        </label>
                        <b-form-select 
                          class="form-select" 
                          @change="CheckPayType" 
                          v-model="payment_type"
                        >
                          <option value="1">Cash Payment</option>
                          <option value="2">Group Account</option>
                          <option value="3">Personal Account</option>
                          <option value="4">Insurance</option>
                        </b-form-select>
                      </div>

                      <div class="form-group mb-3">
                        <label class="form-label fw-medium">
                          <i class="mdi mdi-doctor text-muted"></i> Attach Doctor
                          <span class="text-muted small">(optional)</span>
                        </label>
                        <multiselect
                          v-model="assignedDoctor"
                          :options="doctors"
                          label="full_name"
                          track-by="id"
                          placeholder="Select staff"
                        />
                      </div>

                      <!-- Insurance Section -->
                      <div v-if="payment_type == 4" class="insurance-section">
                        <div class="alert alert-info border-0 py-2 mb-3">
                          <i class="mdi mdi-information"></i>
                          <small>Please select insurance details</small>
                        </div>

                        <div class="form-group mb-3">
                          <label class="form-label fw-medium">Insurance Company</label>
                          <multiselect 
                            v-model="insurance_company" 
                            @input="FilterInsurancePackage" 
                            :options="insurancecompanies" 
                            label="name"
                            placeholder="Select insurance company"
                          />
                        </div>

                        <div class="form-group mb-3">
                          <label class="form-label fw-medium">Insurance Package</label>
                          <multiselect 
                            v-model="insurance_package" 
                            @input="FilterInsuranceCategory" 
                            :options="insurancespackagescost" 
                            label="package_name"
                            placeholder="Select package"
                          />
                        </div>

                        <div class="form-group mb-3">
                          <label class="form-label fw-medium">Service Category</label>
                          <multiselect 
                            v-model="insurance_category" 
                            @input="FilterInsuranceService" 
                            :options="insuranceServiceCategories" 
                            label="name"
                            placeholder="Select category"
                          />
                        </div>

                        <div class="form-group mb-3">
                          <label class="form-label fw-medium">Service Name</label>
                          <multiselect 
                            v-model="insurance_service" 
                            @input="FilterInsurancePrice" 
                            label="name" 
                            :options="insurancesservices"
                            placeholder="Select service"
                          />
                          <small v-if="insurederror" class="text-danger d-block mt-1">
                            <i class="mdi mdi-alert-circle-outline"></i> {{ insurederror }}
                          </small>
                        </div>

                        <div class="form-group mb-3">
                          <label class="form-label fw-medium">Service Cost ({{ userData.currency }})</label>
                          <input 
                            v-model="service_price" 
                            :readonly="userData.permissions['edit_service_cost'] != 1"
                            type="number" 
                            class="form-control" 
                            placeholder="0"
                          />
                        </div>
                      </div>

                      <!-- Non-Insurance Section -->
                      <div v-else class="non-insurance-section">
                        <!-- Account Balance -->
                        <div class="form-group mb-3" v-show="showaccountbalance">
                          <div class="card border-primary">
                            <div class="card-body p-3">
                              <label class="form-label fw-medium mb-2">Account Balance</label>
                              <h4 class="text-primary mb-0">
                                {{ commas(account_balance) }} {{ userData.currency }}
                              </h4>
                            </div>
                          </div>
                        </div>

                        <!-- Account Name -->
                        <div class="form-group mb-3" v-show="showaccounts">
                          <label class="form-label fw-medium">Account Name</label>
                          <input 
                            v-model="account_name" 
                            readonly 
                            type="text" 
                            class="form-control bg-white" 
                          />
                          <input v-model="account_number" hidden type="text" />
                        </div>

                        <!-- Service Category -->
                        <div class="form-group mb-3">
                          <label class="form-label fw-medium">
                            Service Category <span class="text-danger">*</span>
                          </label>
                          <multiselect 
                            v-model="service_category" 
                            @input="FilterCategory" 
                            :options="filteredServiceCategories" 
                            label="name"
                            placeholder="Select service category"
                          />
                        </div>

                        <!-- Service Name -->
                        <div class="form-group mb-3">
                          <label class="form-label fw-medium">
                            Service Name <span class="text-danger">*</span>
                          </label>
                          <multiselect 
                            v-model="service_name" 
                            label="name" 
                            @input="FilterPrice" 
                            :options="services"
                            placeholder="Select service"
                          />
                        </div>

                        <!-- Service Cost -->
                        <div class="form-group mb-3">
                          <label class="form-label fw-medium">
                            Service Cost ({{ userData.currency }}) <span class="text-danger">*</span>
                          </label>
                          <input 
                            v-model="service_price" 
                            :readonly="userData.permissions['edit_service_cost'] != 1"
                            type="number" 
                            class="form-control" 
                            placeholder="0"
                          />
                        </div>
                      </div>

                      <!-- Error Messages -->
                      <div v-if="error" class="alert alert-danger border-0 py-2 mb-3">
                        <i class="mdi mdi-alert-circle-outline"></i>
                        <small>{{ error }}</small>
                      </div>

                      <!-- Submit Button -->
                      <div class="form-group mt-4">
                        <b-button 
                          type="submit" 
                          class="btn w-100 btn-lg" 
                          :disabled="!balancebtn || isSubmittingPatient" 
                          variant="primary"
                        >
                          <i class="mdi mdi-check-circle"></i> 
                          Submit Patient Visit
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="import-patients-new" centered title="Import Patients" title-class="font-18" hide-footer>
      <form
        @submit.prevent="importPatientsFile"
        class="import-modal-drop-target"
        :class="{ 'drag-over': isDragOver }"
        @dragenter.prevent="onImportDragEnter"
        @dragover.prevent="onImportDragOver"
        @dragleave.prevent="onImportDragLeave"
        @drop.prevent="onImportDrop"
      >
        <div class="alert alert-info">
          <h6 class="alert-heading mb-2">Import Rules</h6>
          <ul class="mb-0 ps-3">
            <li>Use the template file from this popup.</li>
            <li>Required: <code>name</code>, <code>gender</code>, <code>date_of_birth</code>, <code>nationality</code>, <code>address</code>, <code>telephone</code>.</li>
            <li>Optional: <code>nin</code>.</li>
            <li>Gender accepted: Male/Female or M/F or 1/2.</li>
            <li>Date format: YYYY-MM-DD or DD/MM/YYYY.</li>
            <li>Telephone: digits only, at least 9 digits. In Excel, set the telephone column to Text.</li>
          </ul>
        </div>

        <div class="form-group mb-3">
          <b-button
            type="button"
            variant="outline-primary"
            @click="downloadPatientTemplate"
            :disabled="isImporting || isTemplateDownloading"
          >
            <template v-if="isTemplateDownloading">
              <b-spinner small></b-spinner> Downloading template...
            </template>
            <template v-else>
              <i class="mdi mdi-download"></i> Download Template
            </template>
          </b-button>
        </div>

        <div v-if="templateMessage" class="alert mb-3" :class="templateSuccess ? 'alert-success' : 'alert-danger'">
          {{ templateMessage }}
        </div>

        <div class="form-group mb-3" v-if="!selectedImportFile">
          <label>Upload Completed Template *</label>
          <input
            ref="patientImportFile"
            type="file"
            class="form-control"
            accept=".csv,.xlsx,.xls"
            @change="handlePatientFileUpload"
            :disabled="isImporting"
          />
          <small class="text-muted">Accepted formats: .xlsx, .xls, .csv (Max 5MB)</small>
          <small class="text-muted d-block mt-1">You can also drag and drop your Excel/CSV file anywhere in this popup.</small>
        </div>

        <div v-else class="mb-3">
          <b-badge class="bg-info">
            <i class="mdi mdi-file"></i> {{ selectedImportFile.name }}
          </b-badge>
          <b-button size="sm" variant="link" class="ms-2 p-0" @click="clearPatientImportFile" :disabled="isImporting">
            Remove
          </b-button>
        </div>

        <div v-if="importMessage" class="alert" :class="importSuccess ? 'alert-success' : 'alert-danger'">
          {{ importMessage }}
        </div>

        <div v-if="importErrors.length" class="alert alert-danger">
          <h6 class="mb-2">Please fix the following:</h6>
          <ul class="mb-0 ps-3">
            <li v-for="(errorText, index) in importErrors" :key="index">{{ errorText }}</li>
          </ul>
        </div>

        <div class="form-group d-flex justify-content-end">
          <b-button
            type="button"
            class="btn w-30"
            variant="secondary"
            @click="$bvModal.hide('import-patients-new')"
            :disabled="isImporting"
          >
            Close
          </b-button>
          <b-button
            v-if="!hasImportResponse"
            type="submit"
            class="btn ms-1 w-30"
            variant="primary"
            :disabled="!selectedImportFile || isImporting"
          >
            <template v-if="isImporting">
              <b-spinner small></b-spinner> Uploading...
            </template>
            <template v-else>
              <i class="fas fa-upload"></i> Upload & Import
            </template>
          </b-button>
        </div>
      </form>
    </b-modal>

    <!-- No Permission View -->
    <div v-if="userData.permissions['new_patient']!=1">
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div class="card border-0 shadow-sm">
            <div class="card-body text-center p-5">
              <div class="mb-4">
                <div class="avatar-xl mx-auto">
                  <div class="avatar-title bg-primary bg-opacity-10 rounded-circle">
                    <i class="mdi mdi-account-plus text-primary" style="font-size: 48px;"></i>
                  </div>
                </div>
              </div>
              <h5 class="text-primary mb-3">Access Restricted</h5>
              <p class="text-muted mb-4">
                You don't have permission to add new patients. Please contact your system administrator.
              </p>
              <img 
                src="@/assets/images/profile-img.png" 
                alt 
                class="img-fluid" 
                style="max-width: 300px; opacity: 0.6;" 
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="psychology-registration-modal"
      centered
      hide-footer
      no-close-on-backdrop
      :no-close-on-esc="isSubmittingPatient"
      :hide-header-close="isSubmittingPatient"
      title=""
      title-class="d-none"
    >
      <form @submit.prevent="AddPatient">
        <div class="mb-3">
          <div class="d-flex align-items-center mb-2">
            <div class="psychology-modal-icon me-2">
              <i class="mdi mdi-head-outline"></i>
            </div>
            <h6 class="mb-0 text-primary">Psychology Consultation Details</h6>
          </div>
          <p class="text-muted mb-0">
            Complete the minimum psychology registration details for this consultation. The registration date will use the selected visit date.
          </p>
        </div>

        <div v-if="psychologyModalError" class="alert alert-danger border-0 py-2 mb-3">
          <i class="mdi mdi-alert-circle-outline"></i>
          <small>{{ psychologyModalError }}</small>
        </div>

        <div v-if="psychologyCategoryLabel" class="alert alert-info border-0 py-2 mb-3">
          <small><strong>{{ psychologyCategoryLabel }}</strong> selected. Complete the section-specific details below if they apply.</small>
        </div>

        <div class="form-group mb-3">
          <label class="form-label fw-medium">Marital Status <span class="text-danger">*</span></label>
          <select v-model="psychology_marital_status" class="form-select" required>
            <option value="">Select status</option>
            <option>Single</option>
            <option>Married</option>
            <option>Separated</option>
            <option>Divorced</option>
            <option>Widowed</option>
          </select>
        </div>

        <div class="form-group mb-3">
          <label class="form-label fw-medium">Residential Status <span class="text-danger">*</span></label>
          <select v-model="psychology_residential_status" class="form-select" required>
            <option value="">Select option</option>
            <option :value="1">Resident</option>
            <option :value="2">Internally Displaced</option>
            <option :value="3">Refugee</option>
            <option :value="4">Migrant</option>
          </select>
        </div>

        <div class="form-group mb-3">
          <label class="form-label fw-medium">Level of Education <span class="text-danger">*</span></label>
          <input
            v-model="psychology_education"
            type="text"
            class="form-control"
            placeholder="Enter level of education"
            required
          />
        </div>

        <div class="form-group mb-3">
          <label class="form-label fw-medium">Occupation <span class="text-danger">*</span></label>
          <input
            v-model="psychology_occupation"
            type="text"
            class="form-control"
            placeholder="Enter occupation"
            required
          />
        </div>

        <div class="form-group mb-4">
          <label class="form-label fw-medium">Referred By <span class="text-muted small">(optional)</span></label>
          <input
            v-model="psychology_referred_by"
            type="text"
            class="form-control"
            placeholder="Referral source"
          />
        </div>

        <div v-if="showPsychologyExtraInfoField" class="form-group mb-4">
          <label class="form-label fw-medium">{{ psychologyExtraInfoLabel }} <span class="text-muted small">(optional)</span></label>
          <textarea
            v-model="psychology_extra_info"
            class="form-control"
            rows="3"
            :placeholder="psychologyExtraInfoPlaceholder"
          ></textarea>
        </div>

        <div v-if="selectedPsychologyCategoryKey === 'psychology_assessments_tests'" class="form-group mb-4">
          <label class="form-label fw-medium">Test Type <span class="text-muted small">(optional)</span></label>
          <input
            v-model="psychology_test_type"
            type="text"
            class="form-control"
            placeholder="Enter the test type"
          />
        </div>

        <div v-if="selectedPsychologyCategoryKey === 'psychology_corporate_services'" class="row">
          <div class="col-md-7">
            <div class="form-group mb-4">
              <label class="form-label fw-medium">Subscribed Company <span class="text-muted small">(optional)</span></label>
              <input
                v-model="psychology_company_name"
                type="text"
                class="form-control"
                placeholder="Company or institution name"
              />
            </div>
          </div>
          <div class="col-md-5">
            <div class="form-group mb-4">
              <label class="form-label fw-medium">Employees Covered <span class="text-muted small">(optional)</span></label>
              <input
                v-model="psychology_employee_coverage"
                type="number"
                min="0"
                class="form-control"
                placeholder="0"
              />
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end gap-2">
          <b-button
            type="button"
            variant="secondary"
            @click="closePsychologyModal"
            :disabled="isSubmittingPatient"
          >
            Cancel
          </b-button>
          <b-button
            type="submit"
            variant="primary"
            :disabled="isSubmittingPatient"
          >
            Save Patient Visit
          </b-button>
        </div>
      </form>
    </b-modal>

    <transition name="save-status-fade">
      <div v-if="saveOverlay.visible" class="save-status-overlay">
        <div class="save-status-card">
          <div v-if="saveOverlay.state === 'loading'" class="modal-spinner-wrap mb-3">
            <div class="spinner-ring"></div>
            <div class="spinner-ring ring-2"></div>
          </div>
          <div v-else class="save-status-success mb-3">
            <i class="mdi mdi-check-circle-outline"></i>
          </div>
          <h5 class="mb-2">{{ saveOverlay.title }}</h5>
          <p class="text-muted mb-0">{{ saveOverlay.message }}</p>
        </div>
      </div>
    </transition>
  </Layout>
</template>

<style scoped>
.card {
  transition: all 0.3s ease;
}

.form-control:focus,
.form-select:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.15);
}

.photo-container,
.photo-preview {
  background-color: #fff;
  overflow: hidden;
}

.avatar-xl {
  width: 80px;
  height: 80px;
}

.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.bg-light {
  background-color: #f8f9fa !important;
}

.alert {
  border-radius: 0.5rem;
}

.btn {
  transition: all 0.3s ease;
  border-radius: 0.5rem;
}

.btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.input-group-text {
  background-color: #e9ecef;
  border-right: none;
}

.input-group .form-control {
  border-left: none;
}

.input-group:focus-within .input-group-text {
  border-color: #0d6efd;
}

.card-title {
  border-bottom: 2px solid #0d6efd;
  padding-bottom: 0.75rem;
}

.save-status-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 1rem;
}

.save-status-card {
  width: min(420px, 92vw);
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.24);
  padding: 2rem 1.5rem;
  text-align: center;
}

.modal-spinner-wrap {
  position: relative;
  width: 88px;
  height: 88px;
  margin: 0 auto;
}

.spinner-ring {
  position: absolute;
  inset: 0;
  border: 4px solid rgba(13, 110, 253, 0.18);
  border-top-color: #0d6efd;
  border-radius: 50%;
  animation: spin-ring 0.9s linear infinite;
}

.spinner-ring.ring-2 {
  inset: 10px;
  border-top-color: #20c997;
  animation-direction: reverse;
  animation-duration: 1.2s;
}

.save-status-success {
  width: 88px;
  height: 88px;
  margin: 0 auto;
  border-radius: 50%;
  background: linear-gradient(135deg, #dcfce7, #bbf7d0);
  color: #15803d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
}

.psychology-modal-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: linear-gradient(135deg, #dbeafe, #bfdbfe);
  color: #1d4ed8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
}

.save-status-fade-enter-active,
.save-status-fade-leave-active {
  transition: opacity 0.25s ease;
}

.save-status-fade-enter,
.save-status-fade-leave-to {
  opacity: 0;
}

.import-modal-drop-target {
  border: 2px dashed transparent;
  border-radius: 0.5rem;
  padding: 0.25rem;
  transition: all 0.2s ease;
}

.import-modal-drop-target.drag-over {
  border-color: #0d6efd;
  background: #eaf2ff;
}

@media (max-width: 991.98px) {
  .col-lg-4 {
    margin-bottom: 1rem;
  }
}

@keyframes spin-ring {
  to {
    transform: rotate(360deg);
  }
}
</style>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import {WebCam} from "vue-web-cam";
import Multiselect from "vue-multiselect";
import { patientMethods, patientComputed , countriesMethods, countriesComputed , serviceCategoryMethods,serviceCategoryComputed, insurancesMethods, insurancesComputed , packagesComputed,packagesMethods} from "@/state/helpers";

export default {
  page: {
    title: "Add Patient",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Add Patient",
      items: [{text: "Dashboard",href: "/"},{text: "Patients",active: true}],
      services:[],
      insurances:[],
      packages:[],
      doctors: [],
      insurancespackagescost:[],
      insurancescategory:[],
      insurancesservices:[],
      patient_name: "",
      telephone: "",
      visitdate: new Date().toLocaleDateString('fr-CA'),
      dateofbirth:new Date().toLocaleDateString('fr-CA'),
      // nationality: "Uganda",
      ageValue: null, 
      ageUnit: "years", 
      inputType: "dateofbirth",
      nationality: { name: "Uganda"},
      age: "",
      gender: "Female",
      email: "",
      address: "",
      nin: "",
      nokname: "",
      nokcontact: "",
      nokrelationship: "",
      payment_type: "1",
      specification: "",
      insurance_company:'',
      insurance_package:'',
      insurance_category:'',
      insurance_service:'',
      insurance_cost:'',
      assignedDoctor: null,
      service_category: "",
      service_name: "",
      service_price: "",
      account_balance:0,
      showaccountbalance:false,
      balancebtn:true,
      error:'',
      // error1:'',
      insurederror:'',
      showaccounts:false,
      account_name:'',
      account_number:'',
      notifications:'',
      photo:null,
      patientphoto:'',
      selectdev:true,
      psychology_registration_date: new Date().toLocaleDateString('fr-CA'),
      psychology_marital_status: '',
      psychology_residential_status: '',
      psychology_education: '',
      psychology_occupation: '',
      psychology_siblings: '',
      psychology_referred_by: '',
      psychology_mood: '',
      psychology_appearance: '',
      psychology_interaction_style: '',
      psychology_eye_contact: '',
      psychology_memory: '',
      psychology_affection_tone: '',
      psychology_extra_info: '',
      psychology_company_name: '',
      psychology_employee_coverage: '',
      psychology_test_type: '',
      routePatientPrefillApplied: false,
      selectedImportFile: null,
      isImporting: false,
      isTemplateDownloading: false,
      importErrors: [],
      importMessage: '',
      importSuccess: false,
      hasImportResponse: false,
      templateMessage: '',
      templateSuccess: false,
      isDragOver: false,
      isSubmittingPatient: false,
      psychologyModalError: '',
      lastPendingBalanceToastKey: '',
      saveOverlay: {
        visible: false,
        state: 'loading',
        title: '',
        message: '',
      },
    
    };
  },
  methods: {
    ...patientMethods,
    ...countriesMethods,
    ...serviceCategoryMethods,
    ...insurancesMethods,
    ...packagesMethods,
    async fetchBusinessDoctors() {
      await axios.get('/systemusers').then((response) => {
        this.doctors = response.data.users || [];
        this.applyRoutePatientPrefill();
      });
    },
    applyRoutePatientPrefill() {
      if (this.routePatientPrefillApplied) {
        return;
      }

      const routePatient = this.$route.query.patient;
      if (!routePatient) {
        return;
      }

      this.patient_name = routePatient;
      this.routePatientPrefillApplied = true;
      this.FilterPatient();
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    openImportPatientsModal() {
      this.clearPatientImportFile();
      this.importErrors = [];
      this.importMessage = '';
      this.importSuccess = false;
      this.hasImportResponse = false;
      this.templateMessage = '';
      this.templateSuccess = false;
      this.$bvModal.show('import-patients-new');
    },
    handlePatientFileUpload(event) {
      const file = event.target.files[0];
      this.processImportFile(file);
    },
    processImportFile(file) {
      if (!file) {
        this.selectedImportFile = null;
        return;
      }

      const validExtensions = ['.csv', '.xls', '.xlsx'];
      const isValidExtension = validExtensions.some((ext) => file.name.toLowerCase().endsWith(ext));
      if (!isValidExtension) {
        this.importErrors = ['Please upload a valid Excel/CSV file (.xlsx, .xls, .csv).'];
        this.selectedImportFile = null;
        this.clearPatientImportFile();
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        this.importErrors = ['File size must not exceed 5MB.'];
        this.selectedImportFile = null;
        this.clearPatientImportFile();
        return;
      }

      this.importErrors = [];
      this.importMessage = '';
      this.importSuccess = false;
      this.selectedImportFile = file;
    },
    onImportDragEnter() {
      if (this.isImporting) return;
      this.isDragOver = true;
    },
    onImportDragOver() {
      if (this.isImporting) return;
      this.isDragOver = true;
    },
    onImportDragLeave() {
      this.isDragOver = false;
    },
    onImportDrop(event) {
      if (this.isImporting) return;
      this.isDragOver = false;
      const file = event.dataTransfer?.files?.[0] || null;
      this.processImportFile(file);
    },
    clearPatientImportFile() {
      this.selectedImportFile = null;
      this.isDragOver = false;
      if (this.$refs.patientImportFile) {
        this.$refs.patientImportFile.value = '';
      }
    },
    async downloadPatientTemplate() {
      if (this.isTemplateDownloading) {
        return;
      }

      this.isTemplateDownloading = true;
      this.templateMessage = '';
      this.templateSuccess = false;

      try {
        const response = await axios.get('/patients-import-template', { responseType: 'blob' });
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = 'patients_import_template.xlsx';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);
        this.templateSuccess = true;
        this.templateMessage = 'Template downloaded successfully.';
      } catch (error) {
        this.templateSuccess = false;
        this.templateMessage = 'Failed to download the template. Please try again.';
      } finally {
        this.isTemplateDownloading = false;
      }
    },
    async importPatientsFile() {
      if (!this.selectedImportFile || this.isImporting) {
        return;
      }

      this.isImporting = true;
      this.importErrors = [];
      this.importMessage = '';
      this.importSuccess = false;
      this.hasImportResponse = false;

      const formData = new FormData();
      formData.append('file', this.selectedImportFile);

      try {
        const response = await axios.post('/patients-import', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        this.importSuccess = true;
        this.importMessage = response.data.message || 'Patients imported successfully.';
        this.importErrors = [];
        this.hasImportResponse = true;
        this.clearPatientImportFile();
        await this.fetchPatients();
      } catch (error) {
        const responseData = error.response?.data || {};
        this.importSuccess = false;
        this.importMessage = responseData.message || 'Import failed. Please check your file and try again.';
        if (Array.isArray(responseData.errors)) {
          this.importErrors = responseData.errors;
        } else if (responseData.errors && typeof responseData.errors === 'object') {
          this.importErrors = Object.values(responseData.errors).flat();
        } else {
          this.importErrors = [];
        }
        this.hasImportResponse = true;
      } finally {
        this.isImporting = false;
      }
    },

    calculateDateOfBirth() {
      if (this.ageValue !== null && this.ageValue !== "" && this.ageUnit !== "") {
        const today = new Date();
        let dob = new Date();
        
        switch (this.ageUnit) {
          case "years":
            dob.setFullYear(today.getFullYear() - this.ageValue);
            break;
          case "months":
            dob.setMonth(today.getMonth() - this.ageValue);
            break;
          case "weeks":
            dob.setDate(today.getDate() - (this.ageValue * 7));
            break;
          case "days":
            dob.setDate(today.getDate() - this.ageValue);
            break;
          default:
            break;
        }
        
        this.dateofbirth = dob.toISOString().substr(0, 10);
      } else {
        this.dateofbirth = ""; 
      }
    },
    handleInputTypeChange() {
      if (this.inputType === "dateofbirth") {
        this.ageValue = null;
        this.ageUnit = "years";
      } else if (this.inputType === "age") {
        this.dateofbirth = ""; 
      }
    },
    async CheckPayType(){
      if (this.payment_type=='3') {
        let url = `/checkpaytype/${this.patient_name}`;
        await axios.get(url).then((response) => {
          this.account_balance = response.data.balance;
          this.showaccountbalance=true;
          this.balancebtn=true;
          this.error = ""; 
        });
      } else if (this.payment_type=='2') {
        let url = `/findgroupaccountmember/${this.patient_name}`;
        await axios.get(url).then((response) => {
          if (response.data.accounts.length>0) {
            this.account_name = response.data.accounts[0].account.acc_name;
            this.account_number = response.data.accounts[0].account.acc_number;
            this.showaccounts=true;
            this.error = ""; 
            this.showaccountbalance=false;
            this.balancebtn=true;
          } else {
            this.account_name ='';
            this.account_number = '';
            this.showaccountbalance=false;
            this.showaccounts=false;
            this.error = "Patient doesn`t belong to any active Group Account."; 
            this.balancebtn=false;
          }
        });
      } 
      // else if (this.payment_type=='4'){
      //   let url = `/checkinsurance/${this.insurance_company}`;
      //   await axios.get(url).then((response) => {
          
      //   });

      // }
      else {
        this.balancebtn=true;
        this.showaccounts=false;
        this.showaccountbalance=false;
        this.error='';
      }
    },
    async FilterInsurancePackage() {

      let url = `/packagebyinsurance/${this.insurance_company.id}`;
    
        await axios.get(url).then((response) => {
    
          this.insurancespackagescost = response.data.insurancespackagescost;
        })
     
    },

    async FilterInsuranceCategory() {

      let url = `/categorybyinsurance/${this.insurance_package.id}`;

          await axios.get(url).then((response) => {

            this.insurancescategory = response.data.insurancescategory;
  })

  },
    async FilterInsuranceService() {

    // let url = `/servicebyinsurance/${this.insurance_category.package_service_category},${this.insurance_package.id}`;
    let url = `/servicebyinsurance/${this.insurance_category.id},${this.insurance_package.id}`;

        await axios.get(url).then((response) => {

          this.insurancesservices = response.data.insurancesservices;
          if (response.data.insurancesservices=='') {
            this.insurederror = "Service not offered on this Insurance category"; 
          }
          else {
            this.insurederror = ""; // Reset error message when services are available
        }
      })

    },

    async FilterInsurancePrice(){
            let url = `/insuranceprice/${this.insurance_service.id}`;
            await axios.get(url).then((response) => {
              this.service_price = response.data.insuranceprice;
              if (response.data.insuranceprice=='') {
            this.error = "Service not offered on this Insurance category"; 
          } else{
            this.error = "";
          }
              });

              
          },
   
    async FilterCategory(){
      this.service_name = "";
      this.service_price = "";
      let url = `/servicebycategory/${this.service_category.id}?context=patient_registration`;
        await axios.get(url).then((response) => {
          this.services = response.data.services;
        });
    },

    async FilterPrice(){
        let url = `/serviceprice/${this.service_name.id}`;
        await axios.get(url).then((response) => {
          this.service_price = response.data.price;
          if (this.payment_type=='3') {
            this.balance=this.account_balance-this.service_price;
            if (this.balance<0) {
              this.balancebtn=false;
              this.error="Insufficient Balance";
            } else {
              this.error='';
              this.balancebtn=true;
            }            
          } else {
              this.error='';
              this.balancebtn=true;
            }  
          });

        if (this.showPsychologyFields) {
          this.psychologyModalError = '';
          this.$nextTick(() => {
            this.$bvModal.show('psychology-registration-modal');
          });
        }
      },
 
    async FilterPatient(){
      let url = `/findpatient/${this.patient_name}`;
      await axios.get(url).then((response) => {
        const patient = response?.data?.patients?.[0];
        if (patient) {
          this.telephone = patient.telephone || "";
          this.dateofbirth = patient.date_of_birth || "";
          this.address = patient.address || "";
          this.nin = patient.nin || "";
          this.email = patient.email || "";
          this.gender = patient.gender || this.gender;
          const doctorId = patient.doctor_id;
          this.assignedDoctor = this.doctors.find((doctor) => doctor.id === doctorId) || null;
        }
      }).catch(() => {});

        let url1 = `/findpatientbalance/${this.patient_name}`;
        await axios.get(url1).then((response) => {
          const balance = Number(response.data.balance || 0);
          if (balance > 0) {
            this.error = "Patient has a pending balance " + balance + " " + this.userData.currency;
            const toastKey = `${this.patient_name}|${balance}`;
            if (this.lastPendingBalanceToastKey !== toastKey) {
              this.lastPendingBalanceToastKey = toastKey;
              this.$toast.warning(this.error, {
                title: "Pending Balance",
              });
            }
          } else {
            this.error = "";
            this.lastPendingBalanceToastKey = '';
          }
        }).catch(() => {
          this.error = "";
          this.lastPendingBalanceToastKey = '';
        });
    },
    handlePatientSubmit() {
      this.psychologyModalError = '';
      if (this.showPsychologyFields) {
        this.$bvModal.show('psychology-registration-modal');
        return;
      }

      this.AddPatient();
    },
    closePsychologyModal() {
      this.psychologyModalError = '';
      this.clearPsychologyFields();
      this.$bvModal.hide('psychology-registration-modal');
    },
    showSaveOverlay(state, title, message) {
      this.saveOverlay = {
        visible: true,
        state,
        title,
        message,
      };
    },
    hideSaveOverlay() {
      this.saveOverlay.visible = false;
    },
    resetPatientForm() {
      this.patient_name="";
      this.telephone="";
      this.address="";
      this.email="";
      this.nin="";
      this.nokname="";
      this.nokcontact="";
      this.nokrelationship="";
      this.service_category="";
      this.service_name="";
      this.service_price="";
      this.insurance_company="";
      this.insurance_category="";
      this.insurance_package="";
      this.insurance_service="";
      this.assignedDoctor = null;
      this.showaccountbalance=false;
      this.showaccounts=false;
      this.services=[];
      this.error = "";
      this.insurederror = "";
      this.balancebtn=true;
      this.clearPsychologyFields();
    },
    async finalizeSuccessfulSave(message = "Patient visit saved successfully.") {
      this.showSaveOverlay('success', 'Saved Successfully', message);
      await this.fetchPatients();
      this.resetPatientForm();
      this.$bvModal.hide('psychology-registration-modal');
      window.setTimeout(() => {
        this.hideSaveOverlay();
      }, 1400);
    },
    resolveSubmitError(err) {
      return err?.response?.data?.message || "Failed to save patient visit. Please try again.";
    },

async take_photo () {  
const image = await this.$refs.webcam.capture(); 
this.photo = image;
const binaryData = this.convertBase64ToBinary(image);
this.saveBinary(binaryData);
},

convertBase64ToBinary(base64String) {
const byteString = atob(base64String.split(',')[1]);
const byteNumbers = new Array(byteString.length);
for (let i = 0; i < byteString.length; i++) {
  byteNumbers[i] = byteString.charCodeAt(i);
}
const byteArray = new Uint8Array(byteNumbers);
return byteArray;
},

saveBinary(binaryData) {

const blob = new Blob([binaryData], { type: 'image/jpeg' });

this.patientphoto= blob;

},
    async AddPatient() { 
        this.error = "";
        this.psychologyModalError = "";
        this.balancebtn=false;
        this.isSubmittingPatient = true;
        this.showSaveOverlay('loading', 'Saving Patient Visit', 'Please wait while we register the patient and visit details.');
        let formData = new FormData();
        formData.append("patient", this.patient_name);
        formData.append("visitdate", this.visitdate);
        formData.append("telephone", this.telephone);
        formData.append("gender", this.gender);
        formData.append("date_of_birth", this.dateofbirth);
        formData.append("nationality", this.nationality.name);
        formData.append("address", this.address);
        formData.append("email", this.email);
        formData.append("nin", this.nin);
        formData.append("nokname", this.nokname);
        if (this.patientphoto ?? false) {
            formData.append('patient_photo', this.patientphoto, 'captured_image.jpg');
        }
        formData.append("nokcontact", this.nokcontact);
        formData.append("nokrelationship", this.nokrelationship);
        formData.append("payment_type", this.payment_type);
        formData.append("account_number", this.account_number);
        formData.append("service_price", this.service_price);
        formData.append("service_category", this.service_category.id ? this.service_category.id : 0);
        formData.append("service_name", this.service_name.id ? this.service_name.id : 0);
        formData.append("insurance_company", this.insurance_company.id ? this.insurance_company.id : 0);
        formData.append("insurance_category", this.insurance_category.id ? this.insurance_category.id : 0);
        formData.append("insurance_package", this.insurance_package.id ? this.insurance_package.id : 0);
        formData.append("insurance_service", this.insurance_service.id ? this.insurance_service.id : 0);
        formData.append("register_under_psychology", this.showPsychologyFields ? 1 : 0);

        if (this.showPsychologyFields) {
          formData.append("psychology_registration_date", this.visitdate);
          formData.append("psychology_marital_status", this.psychology_marital_status);
          formData.append("psychology_residential_status", this.psychology_residential_status);
          formData.append("psychology_education", this.psychology_education);
          formData.append("psychology_occupation", this.psychology_occupation);
          formData.append("psychology_referred_by", this.psychology_referred_by);
          formData.append("psychology_extra_info", this.psychology_extra_info);
          formData.append("psychology_company_name", this.psychology_company_name);
          formData.append("psychology_employee_coverage", this.psychology_employee_coverage);
          formData.append("psychology_test_type", this.psychology_test_type);
        }
        formData.append("doctor_id", this.assignedDoctor && this.assignedDoctor.id ? this.assignedDoctor.id : "");

        let url = "/addpatient";
        await axios.post(url, formData).then(async (response) => {
          if (response.status == 200) {
            await this.finalizeSuccessfulSave();
          }
        }).catch((err) => {
          const message = this.resolveSubmitError(err);
          if (this.showPsychologyFields) {
            this.psychologyModalError = message;
          } else {
            this.error = message;
          }
          this.hideSaveOverlay();
          this.balancebtn = true;
        }).finally(() => {
          this.isSubmittingPatient = false;
        });
      },
    clearPsychologyFields() {
      this.psychology_registration_date=new Date().toLocaleDateString('fr-CA');
      this.psychology_marital_status='';
      this.psychology_residential_status='';
      this.psychology_education='';
      this.psychology_occupation='';
      this.psychology_referred_by='';
      this.psychology_extra_info='';
      this.psychology_company_name='';
      this.psychology_employee_coverage='';
      this.psychology_test_type='';
    },
  },
  computed: {
    ...patientComputed,
    ...countriesComputed,
    ...serviceCategoryComputed,
    ...insurancesComputed,
    ...packagesComputed,
    canRegisterPsychology() { return this.userData?.settings?.psychology == 1 && this.userData?.permissions?.['create_psychology_patient'] == 1; },
    filteredServiceCategories() {
      return this.servicecategories.filter((category) => {
        if (!category.system_key || !category.system_key.startsWith('psychology_')) {
          return true;
        }

        return this.canRegisterPsychology;
      });
    },
    insuranceServiceCategories() {
      return this.servicecategories.filter((category) => !category.system_key || !category.system_key.startsWith('psychology_'));
    },
    selectedPsychologyCategoryKey() {
      if (!this.service_name || !this.service_name.is_psychology_service) {
        return '';
      }

      return this.service_name.category_system_key || this.service_category?.system_key || '';
    },
    psychologyCategoryLabel() {
      return this.service_name?.category?.name || this.service_category?.name || '';
    },
    showPsychologyExtraInfoField() {
      return ['psychology_consultations', 'psychology_group_programs', 'psychology_sensitive_services'].includes(this.selectedPsychologyCategoryKey);
    },
    psychologyExtraInfoLabel() {
      if (this.selectedPsychologyCategoryKey === 'psychology_group_programs') {
        return 'Participants / Session Notes';
      }
      if (this.selectedPsychologyCategoryKey === 'psychology_sensitive_services') {
        return 'Additional Sensitive Service Context';
      }
      return 'Additional Psychology Information';
    },
    psychologyExtraInfoPlaceholder() {
      if (this.selectedPsychologyCategoryKey === 'psychology_group_programs') {
        return 'List participants attending this session and any related context.';
      }
      if (this.selectedPsychologyCategoryKey === 'psychology_sensitive_services') {
        return 'Capture any extra context for this sensitive psychology service.';
      }
      return 'Optional extra information for this psychology service.';
    },
    showPsychologyFields() {
      return this.canRegisterPsychology && !!this.selectedPsychologyCategoryKey;
    },
  },
  watch: {
    service_name(newValue, oldValue) {
      const newIsPsychology = !!(newValue?.is_psychology_service && (newValue?.category_system_key || this.service_category?.system_key));
      const oldIsPsychology = !!(oldValue?.is_psychology_service && (oldValue?.category_system_key || this.service_category?.system_key));

      if (newIsPsychology && !oldIsPsychology && this.canRegisterPsychology) {
        this.psychologyModalError = '';
        this.$nextTick(() => {
          this.$bvModal.show('psychology-registration-modal');
        });
      }
    },
    showPsychologyFields(newValue, oldValue) {
      if (!newValue && oldValue) {
        this.clearPsychologyFields();
        this.psychologyModalError = '';
        this.$bvModal.hide('psychology-registration-modal');
      }
    },
  },
  
  created() {
    this.fetchPatients();
    this.fetchServiceCategory();
    this.fetchCountries();
    this.fetchInsurances();
    this.fetchInsurancePackages();
    this.fetchBusinessDoctors();
    this.nationality = this.countries.find(option => option.name = 'Uganda');
  },
  mounted(){
    this.nationality = this.countries.find(option => option.name = 'Uganda');
    this.applyRoutePatientPrefill();
  },
};
</script>

